<template>
    <ion-item-option :color="ION_VARIANT.LIGHT" class="max-height">
        <ion-button :color="ION_VARIANT.CORAL" class="max-size box-button">
            <ion-icon icon="assets/icon/delete.svg" class="light-light-color" style="height: 100%;"/>
        </ion-button>
    </ion-item-option>
</template>

<script setup lang="ts">
import { IonButton, IonIcon, IonItemOption } from "@ionic/vue";

import { ION_VARIANT } from "@/types/enum/ionicEnum";
</script>

<style scoped>
.box-button {
    border-radius: 16px;
    height: 100%;
    width: 112%;
    aspect-ratio: 38 / 34;
}
</style>
